import CreateSpotifyReportContainer from 'wb-spotify/app/routes/reports/create/container';
import useCreateRedditReport from 'wb-reddit/app/routes/reports/create/useCreateRedditReport';
import { AnimatePresence } from 'framer-motion';
import SpotifyReportsList from 'wb-spotify/app/routes/reports/list';
import 'wb-reddit/app/routes/reports/redditReports.scss';
import useRedditReportUrlOverlay from 'wb-reddit/app/routes/reports/hooks/useRedditReportUrlOverlay';

const SpotifyReports = () => {
	const {
		filters,
	} = useCreateRedditReport();

	useRedditReportUrlOverlay();

	return (
		<AnimatePresence mode="wait">
			{
				Object.keys(filters).length > 0 ? <CreateSpotifyReportContainer
					key="report-mutator"
				/> : <SpotifyReportsList
					key="report-list"
				/>
			}
		</AnimatePresence>
	);
};

export default SpotifyReports;
